// @mui
import { List, Stack } from "@mui/material";
// locales
import { useLocales } from "../../../locales";
//
import { NavSectionProps } from "../types";
import { StyledSubheader } from "./styles";
import NavList from "./NavList";
import { RootState } from "src/redux/store";
import { useSelector } from "react-redux";

// ----------------------------------------------------------------------

export default function NavSectionVertical({
  data,
  sx,
  ...other
}: NavSectionProps) {
  const { translate } = useLocales();
  const authState = useSelector((state: RootState) => state.auth);
  const showModules = authState.userReturn.modules.includes("scheduleCalendar") || authState.userReturn.modules.includes("scheduleCalendarEdit") || authState.userReturn.modules.includes("restaurantDashboard") || authState.userReturn.modules.includes("restaurantOrders");
  const topGroups = data.filter((group) => !group.bottom);
  const bottomGroups = data.filter((group) => group.bottom);

  return (
    <Stack sx={{ height: 1, ...sx }} {...other}>
      <Stack>
        {topGroups.map((group) => {
          const key = group.subheader || group.items[0].title;

          return (
            <List key={key} disablePadding sx={{ px: 2 }}>
              {((showModules && group.subheader ==='Modulos')) && (
                <StyledSubheader disableSticky>{`${translate(
                  group.subheader
                )}`}</StyledSubheader>
              )}

              {group.items.map((list) => (
                <NavList
                  key={list.title + list.path}
                  data={list}
                  depth={1}
                  hasChild={!!list.children}
                />
              ))}
            </List>
          );
        })}
      </Stack>
      {bottomGroups.length > 0 && !authState?.userReturn?.isSubUser && !authState.userReturn.modules.includes("") && (
        <Stack sx={{ mt: "auto", pb: 2 }}>
          {bottomGroups.map((group) => {
            const key = group.subheader || group.items[0].title;

            return (
              <List key={key} disablePadding sx={{ px: 2 }}>
                {group.subheader && (
                  <StyledSubheader disableSticky>{`${translate(
                    group.subheader
                  )}`}</StyledSubheader>
                )}

                {group.items.map((list) => (
                  <NavList
                    key={list.title + list.path}
                    data={list}
                    depth={1}
                    hasChild={!!list.children}
                  />
                ))}
              </List>
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}
